import React, { useState } from 'react'

import {
  Box,
  Button,
  ButtonWithIcon,
  Flex,
} from 'app/components/design-system-components'
import { SearchRounded } from 'app/components/design-system-components/icons/actions'
import { TuneRounded } from 'app/components/design-system-components/icons/image'
import { Input } from 'app/components/design-system-components/inputs'
import { Text } from 'app/components/design-system-components/typography'
import { theme } from 'app/match/applicationReportPDF/assets/theme'
import { hasAppliedFilters } from 'app/pages/teams/rental-references/components/SearchAndFilter/filters.config'
import { RRTableAppliedFilters } from 'app/pages/teams/rental-references/components/SearchAndFilter/RRTableAppliedFilters'
import { RRTableFilters } from 'app/pages/teams/rental-references/components/SearchAndFilter/RRTableFilters'
import { isMobile } from 'app/shared_components/helpers'
import * as Features from 'config/features'

const filterByTextElem = (
  <Text
    as="span"
    fontWeight={theme.fontWeights[6]}
    fontSize={theme.fontSizes.pSmall12}
    color={theme.colors.gray600}
    mr={4}
    minWidth={theme.width[8] + 'px'}
  >
    FILTER BY:{' '}
  </Text>
)

const SearchInputBox = ({ searchText, onSearchChange, placeholderText }) => {
  return (
    <Input
      icon={
        <SearchRounded
          style={{
            color: theme.colors.gray500,
            width: theme.width[6] + 'px',
            height: theme.width[6] + 'px',
          }}
        />
      }
      inputProps={{
        placeholder: placeholderText,
        value: searchText,
        onChange: onSearchChange,
      }}
      maxWidth={theme.width[30] * 2 + 'px'}
      mr={theme.space[1] + 'px'}
      height={theme.height[18] + 'px'}
    />
  )
}

const SearchAndFilter = ({
  filterValues,
  inputTextPlaceholder,
  onChangeFilterValues,
  onSearchTextChange,
  managers,
  onClearFilterValues,
  statusOptions,
  sortOptions,
  managerList,
  podsList,
  teamSlug,
  isPodsDisabled,
}) => {
  const [filtersExpanded, setFiltersExpanded] = useState(false)
  const hasFiltersApplied = hasAppliedFilters(filterValues)

  const onFiltersButtonClicked = () => {
    setFiltersExpanded(!filtersExpanded)
  }

  const filtersSortActionsElem = (
    <Flex alignItems="center" justifyContent="flex-end">
      <ButtonWithIcon
        variant={filtersExpanded ? 'outlineDeepBlue' : 'outline'}
        IconCmp={TuneRounded}
        leading={false}
        mr={theme.space[3] + 'px'}
        onClick={onFiltersButtonClicked}
        iconContainerProps={
          isMobile() && {
            style: {
              marginLeft: 0,
            },
          }
        }
      >
        {!isMobile() && (hasFiltersApplied ? 'Filters Applied' : 'Filter')}
      </ButtonWithIcon>
      <Button variant="outline" onClick={onClearFilterValues}>
        Clear
      </Button>
    </Flex>
  )

  return (
    <Box mt={theme.space[6] + 'px'}>
      <Flex alignItems="center" justifyContent="space-between">
        <SearchInputBox
          searchText={filterValues.search}
          onSearchChange={onSearchTextChange}
          placeholderText={inputTextPlaceholder}
        />

        {filtersSortActionsElem}
      </Flex>

      <Box mt={theme.space[5] + 'px'}>
        {filtersExpanded && (
          <Flex alignItems="center">
            {filterByTextElem}
            <RRTableFilters
              filters={filterValues}
              updateFilter={onChangeFilterValues}
              pods={podsList}
              managers={managerList}
              statusOptions={statusOptions}
              sortOptions={sortOptions}
              includePodsFilter={Features.isPodsFilterEnabledForTeam(teamSlug)}
              isPodsDisabled={isPodsDisabled}
            />
          </Flex>
        )}

        {!filtersExpanded && hasFiltersApplied && (
          <Flex alignItems="center">
            {filterByTextElem}
            <RRTableAppliedFilters
              filters={filterValues}
              onDismissFilter={(filterId) => onChangeFilterValues(filterId, {})}
            />
          </Flex>
        )}
      </Box>
    </Box>
  )
}

export default SearchAndFilter
